module.exports = __webpack_public_path__ + "img/thumbnail_2-01.d1fca7ec.jpg";